import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/src/stylus/app.styl';

import fr from 'vuetify/src/locale/fr';

Vue.use(Vuetify, {
	iconfont: 'md',
	lang: {
		locales: { fr },
		current: 'fr'
	}
});
